/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Filter detections by severity
 * @export
 */
export const ControlSeverity8 = {
    Informational: 'INFORMATIONAL',
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH',
    Critical: 'CRITICAL'
} as const;
export type ControlSeverity8 = typeof ControlSeverity8[keyof typeof ControlSeverity8];


export function ControlSeverity8FromJSON(json: any): ControlSeverity8 {
    return ControlSeverity8FromJSONTyped(json, false);
}

export function ControlSeverity8FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlSeverity8 {
    return json as ControlSeverity8;
}

export function ControlSeverity8ToJSON(value?: ControlSeverity8 | null): any {
    return value as any;
}

